import React, { FC } from 'react'

import { DataTable } from 'packages/components/DataTable'
import {
  FieldDomainEnum,
  ReflectionTypeEnum,
  activityApi,
  fieldApi,
} from 'packages/sdks-next/growp'

import { useBiosColumns } from '../../ReflectionList/biosColumns'
import {
  formatInformStuDataSource,
  formatInformStuSearchParams,
  getSearchFormConfig,
} from '../../ReflectionList/utils'

/**
 * 选择人员
 *
 * @param param0 - 参数
 * @param param0.selectedRowKeys - 选中的行
 * @param param0.activityId - 活动id
 * @param param0.onSelectedRowKeysChange - 选中的行改变
 * @param param0.reflectionType - 人员类型
 * @returns 组件
 */
export const SelectMember: FC<{
  selectedRowKeys: number[]
  activityId: number
  onSelectedRowKeysChange: (selectedKeys: React.Key[]) => void
  reflectionType?: ReflectionTypeEnum
}> = ({
  activityId,
  reflectionType,
  selectedRowKeys,
  onSelectedRowKeysChange,
}) => {
  const domain = reflectionType || FieldDomainEnum.InformalStudent
  const groupNameIn = '固定信息,家庭信息'
  const { biosColumns: columns } = useBiosColumns(domain, true, groupNameIn)

  const { data: groupsData } = fieldApi.useQueryFieldGroups({
    domain,
    query: {
      expand: ['fields'],
      groupNameIn,
    },
  })

  return (
    <DataTable
      api={(q) =>
        activityApi.queryActivityReflections(activityId, {
          expand: ['tasks' as 'ongoingTasks', 'guardians'],
          ...q,
        })
      }
      apiName="activity.queryActivityReflections"
      columns={columns}
      formatData={formatInformStuDataSource}
      formatParams={formatInformStuSearchParams}
      searchFormConfig={getSearchFormConfig(groupsData || [])}
      selectedRowKeys={selectedRowKeys}
      onSelectedRowKeysChange={onSelectedRowKeysChange}
      showSelectedAll={true}
    />
  )
}
